import type { ReactNode } from "react";
import { Button } from "../shadcn/Button";
import { cn } from "@/shared/utils/cn";

export interface TabOption<T extends string> {
  value: T;
  label: ReactNode;
  disabled?: boolean;
  ariaLabel?: string;
}

export interface TabsProps<T extends string> {
  options: readonly TabOption<T>[];
  value: T;
  onValueChange: (value: T) => void;
  label: string;
  className?: string;
}

export function Tabs<T extends string>({ options, value, onValueChange, label, className }: TabsProps<T>) {
  return (
    <div role="group" aria-label={label} className={cn("flex flex-wrap gap-1 rounded-2xl bg-muted p-1", className)}>
      {options.map((option) => (
        <Button
          key={option.value}
          variant={option.value === value ? "default" : "ghost"}
          aria-pressed={option.value === value}
          aria-label={option.ariaLabel}
          disabled={option.disabled}
          onClick={() => onValueChange(option.value)}
          className="flex-1 px-3"
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
}
